import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const streamingDevices = Loadable(() => import('../../containers/web/streamingDevice'));
export default MapTo('vcg/components/soe-home/react/streamingDevices')(streamingDevices);
